/* 🤖 this file was generated by svg-to-ts */
export const emperorIconSynchronize3: {
  name: 'synchronize_3';
  data: string;
} = {
  name: 'synchronize_3',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M6.351 6.351C7.821 4.871 9.821 4 12 4c4.41 0 8 3.58 8 8h2c0-5.515-4.49-10-10-10C9.285 2 6.77 3.089 4.93 4.93L2.99 2.99v6h6L6.341 6.341Z"/><path d="M17.649 17.649c-1.48 1.48-3.48 2.35-5.65 2.35 -4.42 0-8-3.59-8-8h-2c0 5.51 4.48 10 10 10 2.71 0 5.221-1.09 7.06-2.94l1.93 1.93v-6h-6l2.64 2.64Z"/></g></svg>`
};
